import Vue from 'vue'
// Firebase and the modules to be used.
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {

  state: {
    loadedRestaurant: {},
    loadedRestaurantInfo: {},
    loadedCategories: [],
    loadedDishes: [],
  },
  mutations: {
    setRestaurant(state, payload) {
      state.loadedRestaurant = payload
    },
    setLoadedRestaurantInfo(state, payload) {
      state.loadedRestaurantInfo = payload
    },
    setLoadedCategories(state, payload) {
      state.loadedCategories = payload
    },
    setLoadedDishes(state, payload) {
      state.loadedDishes = payload
    },

    updateRestaurant(state, payload) {
      state.loadedRestaurant = payload
    },
    createCategory(state, payload) {
      state.loadedCategories.push(payload)
    },
    updateCategory(state, payload) {
      console.log("Update Called!");
      const category = state.loadedCategories.find(category => {
        return category.id === payload.id
      })
      if (payload.name) {
        category.name = payload.name
      }
      if (payload.image) {
        category.image = payload.image
      }
      if (payload.order) {
        category.order = payload.order
      }
    },
    updateCategories(state, payload) {
      state.loadedCategories = payload
    },
    // Payload will be an the category id.
    deleteCategory(state, payload) {
      state.loadedCategories.splice(state.loadedCategories.findIndex(category => category.id === payload), 1)
    },
    createDish(state, payload) {
      state.loadedDishes.push(payload)
    },
    updateDish(state, payload) {
      const dish = state.loadedDishes.find(dish => {
        return dish.id === payload.id
      });
      if (payload.name) {
        dish.name = payload.name
      }
      if (payload.image) {
        dish.image = payload.image
      }
      if (payload.order) {
        dish.order = payload.order
      }
      if (payload.description) {
        dish.description = payload.description
      }
      if (payload.extras) {
        dish.extras = payload.extras
      }
      if (payload.allergens) {
        dish.allergens = payload.allergens
      }
      if (payload.price) {
        dish.price = payload.price
      }
      if (payload.category_id) {
        dish.category_id = payload.category_id
      }
      //TODO: add visible field
    },
    // Payload will be the dish id.
    deleteDish(state, payload) {
      state.loadedDishes.splice(state.loadedDishes.findIndex(dish => dish.id === payload), 1)
    },
    createRestaurantInfo(state, payload) {
      state.loadedRestaurantInfo = payload
    },
    // When restaurant info is updated or added it for the first time
    updateRestaurantInfo(state, payload) {
      state.loadedRestaurantInfo = payload
    },
  },
  actions: {
    // Data loading methods
    loadRestaurant({ commit }, restaurantId) {
      const restaurant = {
        googleMapUrl: '',
        googleDirectionsUrl: '',
        appBarExtra: '',
        name: '',
        isActive: '',
        ownerUid: '',
        logo: '',
        urlRedirect: '',
        currency: '',
        accent_color_bar: '',
        accent_color_font: '',
        accent_color_font_two: '',
        accent_color_title: '',
        dark_theme: '',
        banner_opacity: '',
        banner_images: [],
        about_images: [],
        deal_image: '',
        phone: '',
        address: '',
        service_logo_one: '',
        service_logo_two: '',
        service_logo_three: '',
        service_logo_four: '',
        service_logo_five: '',
        service_logo_six: '',
        email: '',
        section_bg_one: '',
        section_bg_two: '',
        banner_cover: '',
        useWhatssap: '',
        phoneWhatssap: ''
      };

      firebase.firestore().collection('restaurants').doc(restaurantId).get().then(
        (doc) => {
          const data = doc.data();
          restaurant.id = doc.id;
          restaurant.googleMapUrl = data.googleMapUrl;
          restaurant.googleDirectionsUrl = data.googleDirectionsUrl;
          restaurant.appBarExtra = data.appBarExtra;
          restaurant.name = data.name;
          restaurant.logo = data.logo;
          restaurant.isActive = data.isActive;
          restaurant.ownerUid = data.ownerUid;
          restaurant.urlRedirect = data.urlRedirect;
          restaurant.currency = data.currency;
          restaurant.accent_color_bar = data.accent_color_bar;
          restaurant.accent_color_font = data.accent_color_font;
          restaurant.accent_color_font_two = data.accent_color_font_two;
          restaurant.accent_color_title = data.accent_color_title;
          restaurant.dark_theme = data.dark_theme;
          restaurant.banner_opacity = data.banner_opacity;
          restaurant.banner_images = data.banner_images;
          restaurant.about_images = data.about_images;
          restaurant.deal_image = data.deal_image;
          restaurant.phone = data.phone;
          restaurant.address = data.address;
          restaurant.service_logo_one = data.service_logo_one;
          restaurant.service_logo_two = data.service_logo_two;
          restaurant.service_logo_three = data.service_logo_three;
          restaurant.service_logo_four = data.service_logo_four;
          restaurant.service_logo_five = data.service_logo_five;
          restaurant.service_logo_six = data.service_logo_six;
          restaurant.email = data.email;
          restaurant.section_bg_one = data.section_bg_one;
          restaurant.section_bg_two = data.section_bg_two;
          restaurant.banner_cover = data.banner_cover;
          restaurant.useWhatssap = data.useWhatssap;
          restaurant.phoneWhatssap = data.phoneWhatssap;
          commit("setRestaurant", restaurant);
        }
      ).catch(function (error) {
        console.log('Error getting documents: ', error);
      })
    },
    loadRestaurantInfo({ commit }, restaurantId) {
      firebase.firestore().collection('restaurants').doc(restaurantId).collection(Vue.i18n.translate('info')).get()
        .then(function (querySnapshot) {

          /*TODO: Start of code that solves issues...Improve this code, nothing that
           I know guarantees it can't be overriden by the code below.It'd be cleaner if I could call
           vuext store methods from within themselves. (Recursion)*/
          if (querySnapshot.empty) {
            firebase.firestore().collection('restaurants').doc(restaurantId).collection('info_en').get().then(
              function (querySnapshotFallback) {
                if (querySnapshotFallback.empty) {
                  console.log("No data in english fallback for restaurant! -> No data to show.");
                } else {
                  querySnapshot = querySnapshotFallback;
                  console.log("English fallback used for restaurant!");
                }
                querySnapshot.forEach(function (doc) {
                  const data = doc.data();
                  const restaurantInfo = {
                    id: doc.id,
                    slogan: data.slogan,
                    opening_hours: data.opening_hours,
                    about_us_one: data.about_us_one,
                    about_us_two: data.about_us_two,
                    about_us_three: data.about_us_three,
                    deal: data.deal,
                    deal_desc: data.deal_desc,
                    service_title_one: data.service_title_one,
                    service_desc_one: data.service_desc_one,
                    service_title_two: data.service_title_two,
                    service_desc_two: data.service_desc_two,
                    service_title_three: data.service_title_three,
                    service_desc_three: data.service_desc_three,
                    service_title_four: data.service_title_four,
                    service_desc_four: data.service_desc_four,
                    service_title_five: data.service_title_five,
                    service_desc_five: data.service_desc_five,
                    service_title_six: data.service_title_six,
                    service_desc_six: data.service_desc_six
                  }
                  commit('setLoadedRestaurantInfo', restaurantInfo);
                });
              }).catch(function (error) {
                console.log('Error getting documents: ', error);
              });
            //End of code that solves issues....
          } else {
            querySnapshot.forEach(function (doc) {
              const data = doc.data();
              const restaurantInfo = {
                id: doc.id,
                slogan: data.slogan,
                opening_hours: data.opening_hours,
                about_us_one: data.about_us_one,
                about_us_two: data.about_us_two,
                about_us_three: data.about_us_three,
                deal: data.deal,
                deal_desc: data.deal_desc,
                service_title_one: data.service_title_one,
                service_desc_one: data.service_desc_one,
                service_title_two: data.service_title_two,
                service_desc_two: data.service_desc_two,
                service_title_three: data.service_title_three,
                service_desc_three: data.service_desc_three,
                service_title_four: data.service_title_four,
                service_desc_four: data.service_desc_four,
                service_title_five: data.service_title_five,
                service_desc_five: data.service_desc_five,
                service_title_six: data.service_title_six,
                service_desc_six: data.service_desc_six
              }
              commit('setLoadedRestaurantInfo', restaurantInfo);
            });
          }
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },
    loadRestaurantInfoBySelectedLanguage({ commit, getters }) {
      const restaurantId = getters.restaurantId;
      const selectedLanguage = getters.selectedLang;

      firebase.firestore().collection('restaurants').doc(restaurantId).collection('info_' + selectedLanguage).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data();
            const restaurantInfo = {
              id: doc.id,
              slogan: data.slogan,
              opening_hours: data.opening_hours,
              about_us_one: data.about_us_one,
              about_us_two: data.about_us_two,
              about_us_three: data.about_us_three,
              deal: data.deal,
              deal_desc: data.deal_desc,
              service_title_one: data.service_title_one,
              service_desc_one: data.service_desc_one,
              service_title_two: data.service_title_two,
              service_desc_two: data.service_desc_two,
              service_title_three: data.service_title_three,
              service_desc_three: data.service_desc_three,
              service_title_four: data.service_title_four,
              service_desc_four: data.service_desc_four,
              service_title_five: data.service_title_five,
              service_desc_five: data.service_desc_five,
              service_title_six: data.service_title_six,
              service_desc_six: data.service_desc_six
            };
            commit('setLoadedRestaurantInfo', restaurantInfo);
          });
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },
    loadCategories({ commit }, restaurantId) {
      firebase.firestore().collection('restaurants').doc(restaurantId).collection(Vue.i18n.translate('categories')).orderBy('order').get()
        .then(function (querySnapshot) {
          const categories = [];
          /*TODO: Start of code that solves issues...Improve this code, nothing that
           I know guarantees it can't be overriden by the code below.It'd be cleaner if I could call
           vuext store methods from within themselves. (Recursion)*/
          if (querySnapshot.empty) {
            firebase.firestore().collection('restaurants').doc(restaurantId).collection('categories_en').orderBy('order').get().then(
              function (querySnapshotFallback) {
                if (querySnapshotFallback.empty) {
                  console.log("No data in english fallback for categories! -> No data to show.");
                } else {
                  querySnapshot = querySnapshotFallback;
                  console.log("English fallback used for categories!");
                }
                querySnapshot.forEach(function (doc) {
                  const data = doc.data();
                  categories.push({
                    id: doc.id,
                    order: data.order,
                    name: data.name,
                    image: data.image,
                    starred: data.starred,
                  });
                });
                commit('setLoadedCategories', categories);
                // TODO: BAD TEMPORAL FIX FOR CONTROL PANEL 1st category selection.
                commit('setSelectedCategory', categories[0]);
              }).catch(function (error) {
                console.log('Error getting documents: ', error);
              });
            //End of code that solves issues....
          } else {
            querySnapshot.forEach(function (doc) {
              const data = doc.data();
              categories.push({
                id: doc.id,
                order: data.order,
                name: data.name,
                image: data.image,
                starred: data.starred,
              });
            });
            commit('setLoadedCategories', categories);
          }
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },
    loadCategoriesBySelectedLanguage({ commit, getters }) {
      const restaurantId = getters.restaurantId;
      const selectedLanguage = getters.selectedLang;

      firebase.firestore().collection('restaurants').doc(restaurantId).collection('categories_' + selectedLanguage).orderBy('order').get()
        .then(function (querySnapshot) {
          const categories = [];
          querySnapshot.forEach(function (doc) {
            const data = doc.data();
            categories.push({
              id: doc.id,
              order: data.order,
              name: data.name,
              image: data.image,
              starred: data.starred,
            });
          });
          commit('setLoadedCategories', categories);
          // When loading categories, set the selected category as the 1st one.
          commit('setSelectedCategory', categories[0]);

        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },
    loadDishes({ commit }, restaurantId) {
      firebase.firestore().collection('restaurants').doc(restaurantId).collection(Vue.i18n.translate('dishes')).orderBy('order').get()
        .then(function (querySnapshot) {
          const dishes = [];
          /*TODO: Start of code that solves issues...Improve this code, nothing that
          I know guarantees it can't be overriden by the code below.It'd be cleaner if I could call
          vuext store methods from within themselves. (Recursion)*/
          if (querySnapshot.empty) {
            firebase.firestore().collection('restaurants').doc(restaurantId).collection('dishes_en').get().then(
              function (querySnapshotFallback) {
                if (querySnapshotFallback.empty) {
                  console.log("No data in english fallback for categories! -> No data to show.");
                } else {
                  querySnapshot = querySnapshotFallback;
                  console.log("English fallback used for categories!");
                }
                querySnapshot.forEach(function (doc) {
                  const data = doc.data();
                  dishes.push({
                    id: doc.id,
                    featured: data.featured,
                    category_id: data.category_id,
                    order: data.order,
                    name: data.name,
                    image: data.image,
                    price: data.price,
                    description: data.description,
                    allergens: data.allergens,
                    extras: data.extras
                  });
                });
                commit('setLoadedDishes', dishes);
              }).catch(function (error) {
                console.log('Error getting documents: ', error);
              });
            //End of code that solves issues....
          }
          else {
            querySnapshot.forEach(function (doc) {
              const data = doc.data();
              dishes.push({
                id: doc.id,
                featured: data.featured,
                category_id: data.category_id,
                order: data.order,
                name: data.name,
                image: data.image,
                price: data.price,
                description: data.description,
                allergens: data.allergens,
                extras: data.extras
              });
            });
            commit('setLoadedDishes', dishes);
          }
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },
    loadDishesBySelectedLanguage({ commit, getters }) {
      const restaurantId = getters.restaurantId;
      const selectedLanguage = getters.selectedLang;

      firebase.firestore().collection('restaurants').doc(restaurantId).collection('dishes_' + selectedLanguage).get()
        .then(function (querySnapshot) {
          const dishes = [];
          querySnapshot.forEach(function (doc) {
            const data = doc.data();
            dishes.push({
              id: doc.id,
              category_id: data.category_id,
              order: data.order,
              name: data.name,
              image: data.image,
              price: data.price,
              description: data.description,
              allergens: data.allergens,
              extras: data.extras
            });
          });
          commit('setLoadedDishes', dishes);
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    },

    // CRUDS
    createRestaurant({ commit, getters }, payload) {
      commit('setLoading', true);
      commit('clearError');

      // User
      const userRestaurants = getters.userRestaurants;

      // Restaurant
      const restaurant = {
        isActive: payload.isActive,
        ownerUid: payload.ownerUid,
        // TODO: add restaurant image.
      };

      firebase.firestore().collection("restaurants").doc(payload.id).set(
        restaurant
      ).then(
        () => {
          // Update user and restaurant if it was created successfully
          commit('setRestaurant', { id: payload.id, ...restaurant });

          userRestaurants.push({ id: payload.id, ...restaurant });
          commit('setUserRestaurants', userRestaurants);

          commit('setLoading', false);
        }
      ).catch(
        error => {
          commit('setLoading', false);
          commit('setError', error);
          console.log("Desde index: " + error)
        }
      );
    },
    updateRestaurantInfo({ commit, getters }, payload) {
      const restaurantId = getters.restaurantId;
      const selectedLang = getters.selectedLang;
      console.log("Selected lang to update restaurant info: " + selectedLang);

      const restaurantInfo = {
        name: payload.name,
        slogan: payload.slogan,
        image: payload.image
      };

      // Update, new id for restaurant info is the restaurant_id itself, needed to use .set() or .update() on doc
      if (payload.id) {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('info_' + selectedLang).doc(payload.id)
          .set(restaurantInfo)
          .then(() => {
            commit('updateRestaurantInfo', { ...restaurantInfo, id: payload.id });
            console.log("Restaurant successfully updated!");
          }).catch((error) => {
            console.error("Error updating restaurant info: ", error);
          });
      }
      // Create
      else {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('info_' + selectedLang)
          .add(restaurantInfo)
          .then((doc) => {
            restaurantInfo.id = doc.id;
          })
          .then(() => {
            commit('createRestaurantInfo', restaurantInfo);
            console.log("Restaurant info successfully created!");
          }).catch((error) => {
            console.error("Error adding restaurant info: ", error);
          });
      }
    },
    createCategory({ commit, getters }, payload) {
      const restaurantId = getters.restaurantId;
      const selectedLang = getters.selectedLang;

      const category = {
        order: payload.order,
        name: payload.name,
        image: payload.image
      };

      // Update
      if (payload.id) {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('categories_' + selectedLang).doc(payload.id)
          .set(category)
          .then(() => {
            commit('updateCategory', { ...category, id: payload.id });
            console.log("Category successfully updated!");
          }).catch((error) => {
            console.error("Error adding category: ", error);
          });
      }
      // Create
      else {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('categories_' + selectedLang)
          .add(category)
          .then((doc) => {
            category.id = doc.id;
          })
          .then(() => {
            commit('createCategory', category);
            console.log("Category successfully created!");
          }).catch((error) => {
            console.error("Error adding category: ", error);
          });
      }
    },
    deleteCategory({ commit, getters }, categoryId) {
      const restaurantId = getters.restaurantId;
      const selectedLang = getters.selectedLang;

      if (categoryId === null) return;
      firebase.firestore().collection('restaurants').doc(restaurantId).collection('categories_' + selectedLang)
        .doc(categoryId).delete().then(() => {
          commit("deleteCategory", categoryId);
          console.log("Category successfully deleted!");
        }).catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },
    createDish({ commit, getters }, payload) {
      const restaurantId = getters.restaurantId;
      const selectedLang = getters.selectedLang;

      const dish = {
        id: '',
        order: payload.order,
        name: payload.name,
        category_id: payload.category_id,
        allergens: payload.allergens,
        image: payload.image,
        description: payload.description,
        extras: payload.extras,
        price: payload.price
      };

      // Update
      if (payload.id) {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('dishes_' + selectedLang)
          .doc(payload.id)
          .set(dish)
          .then(
            () => {
              commit("updateDish", { ...dish, id: payload.id, codes: dishCodes });
              console.log("Dish successfully updated!");

            }).catch((error) => {
              console.error("Error adding dish: ", error);
            });
      }
      // Create
      else {
        firebase.firestore().collection('restaurants').doc(restaurantId).collection('dishes_' + selectedLang)
          .add(dish)
          .then((doc) => {
            dish.id = doc.id
          }).then(() => {
            commit("createDish", { ...dish, codes: dishCodes });
            console.log("Dish successfully created!");
          }).catch((error) => {
            console.error("Error adding dish: ", error);
          });
      }
    },
    deleteDish({ commit, getters }, dishId) {
      const restaurantId = getters.restaurantId;
      const selectedLang = getters.selectedLang;

      if (dishId === null) return;
      firebase.firestore().collection('restaurants').doc(restaurantId).collection('dishes_' + selectedLang)
        .doc(dishId).delete().then(() => {
          commit("deleteDish", dishId);
          console.log("Dish successfully deleted!");
        }).catch(function (error) {
          console.error("Error removing dish: ", error);
        });
    },
  },
  getters: {
    loadedRestaurant(state) {
      return state.loadedRestaurant;
    },
    loadedCategories(state) {
      // Here we could also do some data pre-processing like ordering.
      return state.loadedCategories
    },
    loadCategory(state) {
      return (categoryId) => {
        return state.loadedCategories.find((category) => {
          return category.id === categoryId
        })
      }
    },
    loadedDishes(state) {
      return state.loadedDishes
    },
    loadedDishesByCategory(state) {
      return (categoryId) => {
        return state.loadedDishes.filter((dish) => {
          return dish.category_id === categoryId
        })
      }
    },
    loadedRestaurantInfo(state) {
      return state.loadedRestaurantInfo
    },
    loadedDish(state) {
      return state.loadedDish
    },
    loadDish(state) {
      return (dishId) => {
        return state.loadedDishes.find((dish) => {
          return dish.id === dishId
        })
      }
    },
  }

}



// WEBPACK FOOTER //
// ./src/store/restaurant/index.js